import React, {useState} from 'react'
import {
  Input,
  InputProps
} from '../../../views/action-flow/components/library/input'
import {IconButton} from '../buttons/icon-button'

type PasswordInputProps = Omit<InputProps, 'type' | 'buttonRight'>

export const PasswordInput = (props: PasswordInputProps) => {
  const [visible, setVisible] = useState<boolean>(false)

  const passwordProps = {
    ...props,
    type: visible ? 'text' : 'password',
    rightIcon: (
      <IconButton
        data-testid="reveal-password"
        tabIndex={-1}
        appearance="transparent"
        icon={visible ? 'hide' : 'show'}
        onClick={e => {
          e.preventDefault()
          setVisible(!visible)
        }}
        size="large"
      />
    )
  } as InputProps

  return <Input {...passwordProps} />
}
